// About.js
import React from "react";

export default function About() {
  return (
    <section className="section light">
      <div className="container">
        <h1 className="section-title">About MYAC</h1>
        <p className="section-sub">
          We are engineers, innovators, and problem-solvers passionate about building future-ready products.
        </p>

        <div className="grid-2">
          <div className="card card-body">
            <h3>🚀 Our Mission</h3>
            <p>
              MYAC helps businesses harness AI, cloud, and modern engineering to achieve scale and impact.
            </p>
          </div>
          <div className="card card-body">
            <h3>🌍 Our Values</h3>
            <ul>
              <li>Innovation with purpose</li>
              <li>Client-first collaboration</li>
              <li>Scalable, sustainable solutions</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
